import { api } from '@services';

export interface IRequest {
  id: string;
  _id?: string;
  comment: string;
}

const postComments = async ({ id, ...data }: IRequest): Promise<void> => {
  await api.post(`/equipments/${id}/asset/history/comment`, data);
};

export { postComments };
